import { useEffect, useState, useRef } from "react"
import { LoadingData, copyDeepObjects, formattedDatePp, getAttachmentURL, getFileUrl, getUserPictureUrl, timeDifference } from "../../utils/common_lib";
import { getLoggedinUser } from "../../userStore";
import { Icon } from "../../utils/icons";
import { usePusherContext } from "../../components/pusher_context";
import { getFileUuid } from "./messages_lib";
import { MsgAttachment } from "./message_attachments";
import defaultProfileImg from "../../assests/images/default_profile_img.png";

export const MessagesList = props => {
    const [stream, setStream] = useState([]);
    const [imgSrc, setImgSrc] = useState(defaultProfileImg);
    const isInitialMount = useRef(true);
    
    const { msgData, refetchMessages, isFetchingMessages } = props;
    const user = getLoggedinUser();
    const pusherContext = usePusherContext();

    useEffect(() => {
        if(user?.pid){
            const picUrl = getUserPictureUrl(user.pid, 'patient', 100, 100);
            const img = new Image();
            img.onload = () => setImgSrc(picUrl);
            img.onerror = () => setImgSrc(defaultProfileImg);
            img.src = picUrl;
        }
    },[user]);
    
    useEffect(() => {
        if(isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        if(refetchMessages) refetchMessages();
    }, [pusherContext?.pusherData.message]);

    useEffect(() => {
        if(msgData && msgData?.code === 0){
            if(msgData.data?.length > 0){
                parseFeed(copyDeepObjects(msgData.data));
            }else{
                setStream([]);
            }
        }
    },[msgData]);

    const parseFeed = feed => {
        feed.map((v, vIndex) => {
            if(v.ActivityFeed.object == 'message') {
                // Store original date string for time difference calculation
                v.Message.created_original = v.Message.created;
                // Convert date from string to object for TimeAgoPipe 
                v.Message.created = formattedDatePp(v.Message.created);
                let bodyList = getMsgTxt(v);
                let bodyMessage = '';
                if(bodyList[bodyList.length - 1]){
                    let listItem = bodyList[bodyList.length - 1];
                    bodyList[bodyList.length - 1].split('\n\n\n').forEach( (v, k) => {
                        if(k == 0)
                            bodyList[bodyList.length - 1] = v;
                        
                        if(k == 1)
                            bodyMessage = v;
                    });
                }
                v.Message.extractedBody = {
                    list: bodyList,
                    message: bodyMessage
                };

                v.Message.extractedAttachments = v.Message.MessageAttachment?.map( (v, k) => {
                    if(typeof v["type"] != undefined) {
                        const type = getFileType(v);
                        let obj = {
                            type: v['type'],
                            fileType: getFileType(v)
                        };
                        const uuid = getFileUuid(v);
                        if(uuid){
                            obj.url = getAttachmentURL(uuid, type);
                        }else if(v.file){
                            obj.url = getFileUrl(v.file);
                        }
                        if(type == 'image') {
                            obj.sort = 1;
                            obj.thumb = getAttachmentURL(uuid, 'image',  100, 100);
                        }else if(type == 'audio') {
                            obj.sort = 2;
                        }else if(type == 'video') {
                            obj.sort = 3;
                        }else{
                            obj.sort = 4;
                        }
                        return obj;
                    }
                });
                v.isSelf = user.id == v.Message.sender_id;
            }
        });   
        setStream(feed);      
    }

    const getMsgTxt = v => {
        if(v.Message.body.includes('\u2022')){
            return v.Message.body.split('\u2022');
        }else{
            return v.Message.body.split('.');
        }
    }
    const getFileType = v => {
        if(v['type'] == 'internal'){
            if(v['mimeType']){
                return v['mimeType'].split('/')[0];
            }
        }
        return v['type'];
    }
    const timeAgoText = date => {
        const diff = timeDifference(date);
        if(diff){
            // Replace "hrs" with "hour" or "hours" based on the number
            let formatted = diff;
            if(formatted.includes('hrs')){
                const hrsMatch = formatted.match(/(\d+)\s*hrs/);
                if(hrsMatch){
                    const hrsNum = parseInt(hrsMatch[1]);
                    formatted = formatted.replace(/\d+\s*hrs/, hrsNum === 1 ? '1 hour' : hrsNum + ' hours');
                }
            }
            return formatted+' ago';
        }
        return '';
    }

    return (
        <>
            {isFetchingMessages ? <LoadingData msg="Loading messages..." /> : (!stream?.length ? <p>No messages found.</p> : '')}
            {stream?.map((feed, feedIndex) => {
                return (
                        <div key={feedIndex} className="p-2 border-b text-start border-slate-400 bg-slate-50 text-sm">
                            <div className="flex gap-2 mb-1">
                                <div className="example-header-image">
                                    <img src={imgSrc}
                                    alt="user_picture"
                                    className="w-42"
                                    />
                                </div>
                                <div>
                                    <p className="text-sm font-bold mb-1">{ feed.Message.sender_name }</p>
                                    <p className="text-xs fw-midium">
                                        { timeAgoText(feed.Message.created_original || feed.Message.created) } 
                                        {feed.Message.is_urgent == 1 ? <Icon type="flag" color="red" size="4" className="ml-1 text-red-500" /> : ''}
                                    </p>
                                </div>
                            </div>
                            <div>    
                                {feed.Message.extractedBody?.list.map((action, actionIndex) => <span key={actionIndex} className="block">{action}</span>)}
                                
                                {feed.Message.extractedBody?.message && feed.Message.extractedBody?.message != 'null' ? 
                                <div>
                                    <span>{feed.Message.extractedBody?.message} </span>
                                </div> : ''}

                                {feed.Message.extractedAttachments?.length > 0 ? 
                                <div className="message-attachments flex gap-2 mt-2">    
                                    {feed.Message.extractedAttachments?.map((attachment, attachmentIndex) => <MsgAttachment key={attachmentIndex} attachment={attachment} />)}                    
                                </div> : ''}

                            </div>
                        </div>
                )
            }) }
        </>
    )
}